<div
  class="tw:w-full tw:flex-col tw:text-center tw:h-screen tw:flex tw:items-center tw:justify-center tw:bg-[var(--background-splash-screen)] tw:z-[var(--x-zindex-menu)] tw:relative"
>
  <img
    class="tw:mx-auto tw:max-w-[150px] tw:mb-5 tw:transition-all tw:duration-700 tw:ease-out"
    [ngClass]="{
      'tw:opacity-0 tw:translate-y-10': !visible,
      'tw:opacity-100 tw:translate-y-0': visible,
    }"
    [src]="imgUrl"
  />

  @if (showSpinner) {
    <i class="fa fa-spin fa-circle-notch fa-2x tw:text-[var(--spinner-splash-screen)]"></i>
  }
  <ng-content></ng-content>

  <div class="tw:fixed tw:bottom-4 tw:left-0 tw:w-full tw:mt-4">
    <p *ngIf="version" class="tw:text-sm tw:text-[var(--spinner-splash-screen)]">
      {{ 'general.version' | translate }} {{ version }}
    </p>
  </div>
</div>
